<template>
  <div class="select-material">
    <div class="select-header">
        已上传素材
        <span  class="text-color-gray pl20">封面请使用自动生成，高效生成封面</span>
        <div class="del-all"><el-button type="text" @click="handleDelAll">清空</el-button></div>
    </div>
    <div class="select-list">
        <div class="select-list-videos">
            <!-- <div class="auto-generate"><el-button type="primary" plain size="mini">自动生成</el-button></div> -->
            <el-table 
              :data="dataList" 
              row-key="id" 
              :header-cell-style="{background:'#e8eaec',color:'#333'}" 
              height="100%"
              v-el-table-infinite-scroll="loadMoreVideo"
              :infinite-scroll-disabled="videoLoading"
              :infinite-scroll-distance="10"
              :infinite-scroll-immediate="false">
                <el-table-column label="序号" prop="index" align="center" width="80px">
                    <template slot-scope="{ $index }">
                        {{ dataList.length - $index }}
                    </template>
                </el-table-column>
                <el-table-column label="视频" align="center" prop="FILE_TYPE.VIEDO">
                    <template slot-scope="{ row }">
                        <MaterialItem
                            :key="row.id"
                            v-if="row[FILE_TYPE.VIEDO]"
                            :file="row[FILE_TYPE.VIEDO]"
                            :type="row[FILE_TYPE.VIEDO].config.type == FILE_TYPE.VIEDO?'video':'image'"
                            @remove="()=>global.handleSelectData(false, row[FILE_TYPE.VIEDO])"
                            isAimedia
                        />
                    </template>
                </el-table-column>
                <el-table-column label="封面" align="center" :prop="FILE_TYPE.IMAGE">
                    <template slot="header">
                        封面
                        <el-button
                            size="mini"
                            type="primary"
                            plain
                            @click="handleAutoGenerate"
                            :disabled="genLoading"
                        >
                            {{ genLoading? '生成中...' : '自动生成' }}
                        </el-button>
                    </template>
                    <template slot-scope="{ row }">
                        <MaterialItem
                            :key="row.id"
                            v-if="row[FILE_TYPE.COVER]"
                            :file="row[FILE_TYPE.COVER]"
                            :type="row[FILE_TYPE.COVER].config.type == FILE_TYPE.COVER?'image':'video'"
                            @remove="()=>global.handleSelectData(false, row[FILE_TYPE.COVER])"
                            isAimedia
                        />
                    </template>
                </el-table-column>
                <el-table-column label="图片" align="center" :prop="FILE_TYPE.IMAGE">
                    <template slot-scope="{ row }">
                        <MaterialItem
                            :key="row.id"
                            v-if="row[FILE_TYPE.IMAGE]"
                            :file="row[FILE_TYPE.IMAGE]"
                            :type="row[FILE_TYPE.IMAGE].config.type == FILE_TYPE.IMAGE?'image':'video'"
                            @remove="()=>global.handleSelectData(false, row[FILE_TYPE.IMAGE])"
                            isAimedia
                        />
                    </template>
                </el-table-column>
               
            </el-table>
        </div>
    </div>
  </div>
</template>

<script>
import MaterialItem from './materialItem.vue'
import { FILE_TYPE } from './constant'
import _ from 'lodash'
import { genVideoCoverImg } from '@/api'
import ElTableInfiniteScroll from "el-table-infinite-scroll";
export default {
    inject: [ 'global' ],
    components: { MaterialItem },
    directives: {
        "el-table-infinite-scroll": ElTableInfiniteScroll,
    },
    data() {
        return {
            FILE_TYPE,
            genLoading: false,
            videoLoading: false,
            displayVideoList: [],
            pageSize: 20,
            currentVideoPage: 1
        }
    },
    computed: {
        targetAppData() {
            return this.global.selectList[this.global.currentKey] || []
        },
        dataList() {
            return [ ...(this.global.selectList[this.global.currentKey] ||[]) ].reverse()
        },
    },
    methods: {
        // 加载更多视频数据
        loadMoreVideo() {
            if (this.videoLoading) return;
            this.videoLoading = true;
            
            const start = (this.currentVideoPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            const newData = this.dataList.slice(start, end);
            
            if (newData.length > 0) {
                this.displayVideoList = [...this.displayVideoList, ...newData];
                this.currentVideoPage++;
            }
            
            this.videoLoading = false;
        },
        
        // 重置数据
        resetData() {
            this.displayVideoList = [];
            this.currentVideoPage = 1;
            this.loadMoreVideo();
        },
        
        handleDelAll() {
            if (!( this.dataList.length)) {
                this.$message.error('当前没有选中的素材，请添加')
                return
            }
            this.$confirm('将删除所有已选择的素材，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.global.delAllCurAppData();
                this.resetData();
            }).catch(() => {});
        },
        async handleAutoGenerate() {
            this.genLoading = true
            const videoList = this.targetAppData;
            const { autoList = [], generateList =[], autoErrList =[] } = _.groupBy(videoList, (item)=> {
                const data = item[FILE_TYPE.COVER];
                if (data) {
                    return ''
                }else {
                    const videoData = item[FILE_TYPE.VIEDO] || {};
                    if (videoData.img_material_url) {
                         return 'autoList'
                    }else {
                        return 'generateList'
                    }
                }
            });
            if (!(autoList.length || generateList.length )) {
                this.$message.error('没有需要生成的素材');
                this.genLoading = false
                return
            }
            const fileConfigList = this.global.fileConfigList
            const coverList = autoList.map(data=> {
                const {  key, img_full_material_url,  height, width, img_material_url } = data[FILE_TYPE.VIEDO];
                // const materialConfig = _.find(fileConfigList, { type: FILE_TYPE.COVER, conf_resolution: config.conf_resolution  })
                return {
                    id: data.id,
                    key,
                    config: { type: FILE_TYPE.COVER },
                    height,
                    width,
                    full_material_url:img_full_material_url,
                    img_full_material_url,
                    img_material_url,
                    material_url: img_material_url,
                    material_name: img_material_url.slice(img_material_url.lastIndexOf('/') +1)
                }
            });
            console.log(coverList, 'coverListcoverListcoverListcoverList');
            this.global.handleSelectData(true, coverList)
            this.genLoading = false;
        },
        
    },
    watch: {
        selectImgList: {
            handler(newVal) {
                this.resetData();
            },
            deep: true
        },
        dataList: {
            handler(newVal) {
                this.resetData();
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>

.select-material {
    height: 100%;
    border-left: 1px solid #E4E7ED;
    &::v-deep {
        .el-table__header {
            height: 45px;
        }
    }
}
.select {
    &-header {
        height: 40px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        width: 100%;
        &-state {
            cursor: pointer;
        }
        &-icon {
            font-size: 18px;
            margin: 0 6px;
            vertical-align: -2px;
        }
        .del-all {
           margin-left: auto;
           margin-right: 20px;
        } 
    }
    &-list {
        display: flex;
        height: calc(100% - 40px);
        &-imgs {
            flex: 1.2;
            width: 0;
            border-right: 1px solid #E4E7ED;
        }
        &-videos {
            flex: 2;
            width: 0;
            position: relative;
            .auto-generate {
                position: absolute;
                right: 10px;
                top: 6px;
                z-index: 9;
            }
        }
    }
}
</style>